import { HttpErrorResponse } from '@angular/common/http';
import { TimeoutError } from 'rxjs';

export const PROTOCOL_REQUEST_TIMEOUT_MS = 60000;

export function protocolLoadError(error: unknown): string {
  if (error instanceof TimeoutError ||
      (error instanceof HttpErrorResponse && (error.status === 408 || error.status === 504))) {
    return 'Request timed out. Please try again.';
  }
  if (error instanceof HttpErrorResponse && error.status === 404) {
    return 'The selected protocol or history could not be found.';
  }
  return 'Unable to load the selected protocol or history. Please try again.';
}
